import angular from 'angular';
import ProductDetailController from "./productdetail.controller";
import ProductDetailService from "./productdetail.service";
import AddToCartService from "./addtocart.service";
import AddToCartController from "./addtocart.controller";
import EnterPickupController from "./enterpickup.controller";
import RecentlyViewedController from "./recentlyviewed.controller";
import RecentlyViewedService from "./recentlyviewed.service";
import YoursizeEnableController from './yoursize-enable.controller';
import YoursizeSelectController from './yoursize-select.controller';
import ReviewController from './review.controller';
import YoursizeService from './yoursize.service';
import InfoBoxService from './notLoggedInInfoBox.service';

let ProductDetail = angular
    .module('ProductDetail', [])
    .controller('ProductDetailController', ProductDetailController)
    .service('ProductDetailService', ProductDetailService)
    .controller('AddToCartController', AddToCartController)
    .service('AddToCartService', AddToCartService)
    .controller('EnterPickupController', EnterPickupController)
    .controller('RecentlyViewedController', RecentlyViewedController)
    .service('RecentlyViewedService', RecentlyViewedService)
    .controller('YoursizeEnableController', YoursizeEnableController)
    .controller('YoursizeSelectController', YoursizeSelectController)
    .controller('ReviewController', ReviewController)
    .service('YoursizeService', YoursizeService)
    .service('InfoBoxService', InfoBoxService);

export default ProductDetail;
